import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useQuery } from "../../../lib/server-query";
import { retainedQueryData } from "@sx/api-client";
import { EmptyState, Icon } from "@sx/ui";

import { usePrincipalId } from "../../../lib/browser-state";
import { useProjectId } from "../../../shell/project";
import { labelAccessQuery } from "../../../workspaces/label/access";
import { useT } from "../../../workspaces/label/i18n";

/* The Label door checks the human's seat and grader roster on every grading call.
 * This projection only decides which screen to show. */
export const Route = createFileRoute("/_console/label/qc")({
  component: QcLayout,
});

function QcLayout() {
  const t = useT();
  const projectId = useProjectId();
  const principalId = usePrincipalId();
  const access = retainedQueryData(useQuery(labelAccessQuery(principalId, projectId)));
  if (access === undefined) return null;
  if (!access.can_grade) {
    return (
      <EmptyState
        compact
        icon={<Icon name="review-words" />}
        title={t(
          "grade.not_allowed",
          "Grading is open to managers and to the people a manager adds on Principal.",
        )}
      />
    );
  }
  return <Outlet />;
}
